export default "__VITE_ASSET__B1GNv6Gz__"